import { StorageManager } from 'src/app/common/storage-manager.class';
import { environment } from '../../../../../environments/environment';

export class VentasEnvironmentDefinition {
  public appName = environment.appName;
    
  public applicationType = environment.features.applicationType;

  public serverUrl = environment.serverUrl;
  
  public ventaName = environment.features.ventaName;
      
  public sectorName = environment.features.sectorName;
      
  public parcelasName = environment.features.parcelasName;
      
  public tipoSuperficieParcelas = environment.features.hasSuperficieCultivada
          ? 'S.\xa0C.'
          : 'S.\xa0Sigpac';
      
  public showClientesCooperativa = environment.features.showClientesCooperativa;
      
  public showVentasComercio = environment.features.showVentasComercio;
      
  public textoSuperficie = environment.features.textoSuperficie;
      
  public activateApiSIEX = environment.features.activateSIEX;
      
  public hasClients = environment.features.hasClients;
      
  public userCanSeeClientes = this.hasClients && (environment.features.userCanSeeClientes ? true : (StorageManager.getUser().rol === 'admin'));

  public showVentasLote = environment.features.showVentasLote;

  public activateSIEX = environment.features.activateSIEX;

  public hasPlantas = environment.features.hasPlantas;
  
  public fincaName = environment.features.fincaName;
      
  public fincasName = environment.features.fincasName;

  public parcelaName = environment.features.parcelaName;
    
  public canAddVentas = environment.features.canAddVentas;
}// class;